/** What a save would rewrite that nobody asked it to.
 *
 *  The block editor round-trips markdown through remark, and remark's
 *  serialiser is not byte-identical to every way a document can be written —
 *  an escape inside an autolink, a table's column padding. On text nobody
 *  edited that difference is the editor rewriting the author's words for them,
 *  which they should get to refuse. It matters most where the author is not
 *  the one who wrote it: the agent writes task and subtask descriptions, and
 *  reformatting them on an unrelated edit is a diff nobody made.
 *
 *  Capped at eight lines: this feeds a dialog, and a wall of them says nothing
 *  the first few do not.
 */
export function differences(before: string, after: string) {
  const a = before.split("\n")
  const b = after.split("\n")
  const out: { line: number; before: string; after: string }[] = []
  for (let i = 0; i < Math.max(a.length, b.length) && out.length < 8; i++) {
    if ((a[i] ?? "") !== (b[i] ?? "")) out.push({ line: i + 1, before: a[i] ?? "", after: b[i] ?? "" })
  }
  return out
}
